import { AccountingPackageNameId } from '../../Models/Api/AccountingPackage';
import {
    StrongboxImportRequest
} from '../../Utils/ConnectStrongbox';


import {
    IClearRetryImportRequest,
    IImportHasStarted,
    ImportFinancialsActions,
    ISaveImportParameters,
    ISetBorrowerFlowAccountingPkg,
    ISetBorrowerParametersAction,
    ISetConnectionOptions,
    ISetImportCustomerFinancialsAction,
    ISetRetryImportRequest,
    ISetUniversalConnector,
    IToggleBorrowerParametersAction,
    IToggleImportCustomerFinancialsAction,
} from './Actions';

import {
    ConnectionOptions,
    CustomerFinancialsTarget,
    DirectLinkParameters,
    ImportMap
} from './Reducer';

function SetImportCustomerFinancialsActive(
    isActive: boolean,
    target: CustomerFinancialsTarget,
    importingDirect?: DirectLinkParameters
): ISetImportCustomerFinancialsAction {
    return {
        type: ImportFinancialsActions.SetImportCustomerFinancials,
        isActive,
        target,
        importingDirect
    };
}

function ToggleImportCustomerFinancialsActive(): IToggleImportCustomerFinancialsAction {
    return {
        type: ImportFinancialsActions.ToggleImportCustomerFinancials,
    };
}

function SetBorrowerParametersActive(isActive: boolean): ISetBorrowerParametersAction {
    return {
        type: ImportFinancialsActions.SetBorrowerParameters,
        isActive,
    };
}

function ToggleBorrowerParametersActive(): IToggleBorrowerParametersAction {
    return {
        type: ImportFinancialsActions.ToggleBorrowerParameters,
    };
}

function ImportHasStarted(): IImportHasStarted {
    return {
        type: ImportFinancialsActions.ImportHasStarted,
    }
}

function SetConnectionOptions(options?: ConnectionOptions): ISetConnectionOptions {
    return {
        type: ImportFinancialsActions.SetConnectionOptions,
        connectionOptions: options
    }
}

function SaveImportParameters(workspaceId: string, accountingPackage: AccountingPackageNameId, options: StrongboxImportRequest): ISaveImportParameters {
    return {
        type: ImportFinancialsActions.SaveImportParameters,
        workspaceId,
        accountingPackage,
        options
    };
}

function RetryImportRequest(importMap: ImportMap): ISetRetryImportRequest {
    return {
        type: ImportFinancialsActions.SetRetryImportRequest,
        importMap,
    }
}

function ClearRetryImportRequest(): IClearRetryImportRequest {
    return {
        type: ImportFinancialsActions.ClearRetryImportRequest,
    }
}

function SetBorrowerFlowAccountingPkg(accountingPkg: AccountingPackageNameId): ISetBorrowerFlowAccountingPkg {
    return {
        type: ImportFinancialsActions.SetBorrowerFlowAccountingPkg,
        pkg: accountingPkg,
    }
}

function SetBorrowerUniversalConnector(universal: boolean): ISetUniversalConnector {
    return {
        type: ImportFinancialsActions.SetUniversalConnector,
        universal,
    };
}

export const actionCreators = {
    SetImportCustomerFinancialsActive: SetImportCustomerFinancialsActive,
    ToggleImportCustomerFinancialsActive: ToggleImportCustomerFinancialsActive,
    SetBorrowerParametersActive: SetBorrowerParametersActive,
    ToggleBorrowerParametersActive: ToggleBorrowerParametersActive,
    ImportHasStarted: ImportHasStarted,
    SetConnectionOptions: SetConnectionOptions,
    SaveImportParameters: SaveImportParameters,
    RetryImportRequest: RetryImportRequest,
    ClearRetryImportRequest: ClearRetryImportRequest,
    SetBorrowerFlowAccountingPkg: SetBorrowerFlowAccountingPkg,
    SetBorrowerUniversalConnector: SetBorrowerUniversalConnector,
};
